// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const AutosSoaWrapper: StatelessFunctionalComponent<*> = styled.div`
  padding: 20px 10px !important;
  
  .AutosSoa {
    &-vehicleTypes {
      background-color: rgba(0, 0, 0, 0.04);
    }

    &-vehicles {
      background-color: #fff;
      margin-bottom: 40px;
      margin-top: 30px;
    }

    &-vehicle {
      width: 84px;
      height: 110px;
      display: flex;
      flex-direction: column;
      align-items: center
      justify-content: center;
      cursor: pointer;
      margin-left: 30px;
      margin-right: 30px;
    }

    &-vehicleImage {
      width: 8.4em;
      height: 8.4em;
    }

    &-vehicle span {
      color: #555;
      font-weight: bold;
      font-size: 1.6em;
    }

    &-truckOptions {
      display: flex;
      align-items: center;
      justify-content: space-around;
      max-width: 450px;
      margin: 30px auto 0 auto;
    }

    &-truckOptions-item {
      display: flex;
      font-size: 2em;
      align-items: center;
    }

    &-truckOptions-item  .Form-radioWrapper {
      margin-right: 14px;
    }

    &-truckOptions-item[disabled],
    &-vehicle[disabled] {
      opacity: .2;
      cursor: auto;
    }

    &-weight {
      font-size: 1.2rem;
      color: var(--text-color-2);
    }

    &-resultBody {
      border-radius: 3px;
      background-image: linear-gradient(282deg, #0033a0, #00a3c3), linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
      box-shadow: 0 5px 6px 0 rgba(0, 0, 0, 0.24);
      padding: 30px 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      margin-right: auto;
      color: #fff;
      margin-bottom: 30px;
    }
    
    &-resultFooter {
      font-size: 2em;
      text-align: center;
      color: #9a9a9a;
    }
    &-resultInner {
      display: flex;
    }

    &-resultImage {
      margin-right: 20px;
      display: flex;
      align-items: center;
    }
    &-resultImage img {
      max-width: 150px;
      height: auto;
    }
    &-resultTitle {
      font-size: 2em;
      display: block;
    }
    &-resultPrice {
      font-size: 39px;
      font-weight: 600;
    }
    &-resultPrice span {
      font-size: 16px;
      font-weight: 300;
    }

    &-formRow {
      margin-top: 16px;
      display: flex;
      justify-content: center;
    }

    @media (max-width: 700px){
      &-formRow {
        flex-direction: column;
      }
    }

    &-formRow > * {
      margin: 0 10px;
    }

    &-footerContainer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
    }

    &-footer {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      font-size: 12px;
      color: #555;
      margin-left: 18px;
    }

    &-icon-check:after {
      content: '';
      display: block;
      width: 5px;
      height: 12px;
      border: solid var(--blue-light-color);
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      position: relative;
      top: -1px;
    }
  }

  .Form-radioWrapper {
    background-color: #fff;
    border: 1px solid rgb(151, 151, 151, .4);
    border-radius: 4px;
    width: 26px;
    height: 26px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .Form-radioWrapper input {
    margin: 0;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }

  .Form-radioWrapper--on:after {
    content: '';
    display: block;
    width: 5px;
    height: 12px;
    border: solid var(--blue-light-color);
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    position: relative;
    top: -1px;
  }

  .icon-help {
    width: 22px;
    height: 22px;
    background-color: #00339f;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: bold;
  }
`;

export default AutosSoaWrapper;
